import React from 'react';
import { injectIntl } from 'gatsby-plugin-intl';
import Context from '../context/ModalContext';
import AuthContext from '../context/AuthContext';

import Button from '../styledComponents/Button';

const DownloadBtn = ({intl, href}) => {

    return (
        <>
            <AuthContext.Consumer>
                {(authcontext) => (authcontext.data.loginMode ) ? 
                    <Button as="a" href={href} target="_blank" rel="noreferrer noopener">
                        <span>{intl.formatMessage({ id: 'get' })}</span>
                    </Button>
                 : 
                    <Context.Consumer>
                        {context => (
                        <Button onClick={context.updateModalMode}>
                            <span>{intl.formatMessage({ id: 'get' })}</span>
                        </Button>
                        )}
                    </Context.Consumer>
                }
            </AuthContext.Consumer>
        </>
    )
};

export default injectIntl(DownloadBtn);